<template>
  <div id="shadow-token-page">
    <h2>Shadow token</h2>
    <div class="shadow-samples">
      <div v-for="(shadow, name) in shadows" :key="name" :class="name" :style="{ boxShadow: shadow }">
        {{ shadow }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      shadows: {
        'shadow-none': '$shadow-none',
        'shadow-xs': '$shadow-xs',
        'shadow-sm': '$shadow-sm',
        'shadow-md': '$shadow-md',
        'shadow-lg': '$shadow-lg',
        'shadow-xl': '$shadow-xl',
        'shadow-2xl': '$shadow-2xl',
        'shadow-3xl': '$shadow-3xl'
      }
    }
  }
}
</script>

<style lang="scss">
#shadow-token-page {
  .shadow-samples {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  .shadow-samples > div {
    border: 1px solid lightgray; // Add a border for visibility
    margin: 10px; // Space between samples
    display: inline-block; // Display inline for samples
    text-align: center; // Center text
    line-height: 200px; // Center text vertically
    color: #000; // Text color
    border-radius: 24px;
    background-color: white;
  }

  // Shadow Classes
  .shadow-none {
      box-shadow: $shadow-none;
  }

  .shadow-xs {
      box-shadow: $shadow-xs;
  }

  .shadow-sm {
      box-shadow: $shadow-sm;
  }

  .shadow-md {
      box-shadow: $shadow-md;
  }

  .shadow-lg {
      box-shadow: $shadow-lg;
  }

  .shadow-xl {
      box-shadow: $shadow-xl;
  }

  .shadow-2xl {
      box-shadow: $shadow-2xl;
  }

  .shadow-3xl {
      box-shadow: $shadow-3xl;
  }
}

</style>
